<template>
  <div id="page-shop_items">
    <h5 class="m-4 page-header"> >> {{ $t('AUTH.MENU.SHOPITEM') }}</h5>

    <memlist-card>
      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">
            <ShopItemTab />
          </div>
          <div v-show="active_tab === 1">
            <CampaignsTab />
          </div>
        </div>
      </div>
      
    </memlist-card>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ShopItemTab from '@/view/pages/ml/shopitem/ShopItemTab.vue';
import CampaignsTab from '@/view/pages/ml/shopitem/CampaignsTab.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: 'shop_items',
  components: {
    ShopItemTab,
    CampaignsTab
  },
  mixins: [ toasts ],
  computed: {
    tabs() {

      let base = [
        { label: 'PAGES.SHOPITEM.SHOPITEMS', disabled: false },
        { label: 'PAGES.CAMPAIGNS.CAMPAIGNS', disabled: false },

      ];
      
      return base;
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'reg_only']),
  },
  mounted() {

  },
  data() {
    return {
      active_tab: 0,
    };
  },
  watch: {

  },
  methods: {

  }
};
</script>
